import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roof-pitch-calculator',
  component: () => import('../../routes/RoofPitch.svelte'),
  card: {
    id: 'roof-pitch',
    title: 'Roof Pitch Calculator',
    description: 'Calculate roof pitch in degrees, ratio, and percentage. Find slope factor and rafter length for any roof slope.',
    icon: 'roofing',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/roof-pitch-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Roof Pitch Calculator – Degrees, Ratio & Slope Factor',
    description: 'Free roof pitch calculator converts between degrees, ratio (X:12), and percentage. Calculates slope factor and rafter length for roofing and construction projects.',
  },
};

export default meta;
